import React, { useState, useEffect } from 'react';
import TaskList from './TaskList';
import WeekView from './WeekView';
import CalendarView from './CalendarView';

const TABS = [
  { id: 'today',    label: 'Today' },
  { id: 'tomorrow', label: 'Tomorrow' },
  { id: 'week',     label: 'This Week' },
  { id: 'all',      label: 'All Tasks' },
  { id: 'calendar', label: 'Calendar' },
];

const LS_KEY = 'aidey_tasks_active_tab';

function TasksPage({
  displayTasks,
  today,
  tomorrow,
  sortBy,
  setSortBy,
  onViewTask,
  taskTypes,
  undoComplete,
  onMoveTask,
  onAddTask,
  currentUser,
  setSelectedWeekDate,
  setShowWeekModal,
  calendarDate,
  setCalendarDate,
  setSelectedDate,
  setShowCalendarModal,
  tileContent,
  initialTab,
}) {
  const [activeTab, setActiveTab] = useState(() => {
    if (initialTab) return initialTab;
    return localStorage.getItem(LS_KEY) || 'today';
  });

  useEffect(() => {
    if (initialTab && initialTab !== activeTab) {
      setActiveTab(initialTab);
      localStorage.setItem(LS_KEY, initialTab);
    }
  }, [initialTab]); // eslint-disable-line

  const switchTab = (tabId) => {
    setActiveTab(tabId);
    localStorage.setItem(LS_KEY, tabId);
  };

  return (
    <div>
      <style>{`
        .tasks-tab-bar::-webkit-scrollbar { display: none; }
        .tasks-tab-btn {
          padding: 0.45rem 1.1rem;
          border-radius: 20px;
          border: none;
          cursor: pointer;
          font-size: 0.875rem;
          font-weight: 500;
          white-space: nowrap;
          flex-shrink: 0;
          background: #f0f2f4;
          color: #555;
          transition: background 0.15s, color 0.15s;
          font-family: 'Raleway', sans-serif;
        }
        .tasks-tab-btn.active {
          background: #0C2D48;
          color: #fff;
          font-weight: 700;
        }
        .tasks-tab-btn:hover:not(.active) {
          background: #e2e5ea;
          color: #333;
        }
      `}</style>

      {/* Header + Tab bar */}
      <div style={{ padding: '1.25rem 1.5rem 0' }}>
        <h2 style={{ margin: '0 0 1rem' }}>My Tasks</h2>

        <div
          className="tasks-tab-bar"
          style={{
            display: 'flex',
            gap: '0.35rem',
            overflowX: 'auto',
            paddingBottom: '0.75rem',
            borderBottom: '2px solid #f0f0f0',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            WebkitOverflowScrolling: 'touch',
          }}
        >
          {TABS.map((tab) => (
            <button
              key={tab.id}
              onClick={() => switchTab(tab.id)}
              className={`tasks-tab-btn${activeTab === tab.id ? ' active' : ''}`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* View content */}
      {activeTab === 'today' && (
        <TaskList
          tasks={displayTasks}
          mode="Today"
          sortBy={sortBy}
          setSortBy={setSortBy}
          onViewTask={onViewTask}
          today={today}
          tomorrow={tomorrow}
          taskTypes={taskTypes}
          undoComplete={undoComplete}
          onMoveTask={onMoveTask}
          onAddTask={onAddTask}
          currentUser={currentUser}
        />
      )}

      {activeTab === 'tomorrow' && (
        <TaskList
          tasks={displayTasks}
          mode="Tomorrow"
          sortBy={sortBy}
          setSortBy={setSortBy}
          onViewTask={onViewTask}
          today={today}
          tomorrow={tomorrow}
          taskTypes={taskTypes}
          undoComplete={undoComplete}
          onMoveTask={onMoveTask}
          onAddTask={onAddTask}
          currentUser={currentUser}
        />
      )}

      {activeTab === 'week' && (
        <WeekView
          tasks={displayTasks}
          today={today}
          setSelectedWeekDate={setSelectedWeekDate}
          setShowWeekModal={setShowWeekModal}
          setViewTask={onViewTask}
          onNavigateDay={(date) => {
            const todayStr    = today.toDateString();
            const tomorrowStr = tomorrow.toDateString();
            if (date.toDateString() === todayStr) {
              switchTab('today');
            } else if (date.toDateString() === tomorrowStr) {
              switchTab('tomorrow');
            } else {
              setSelectedWeekDate(date);
              setShowWeekModal(true);
            }
          }}
          onAddTask={onAddTask}
        />
      )}

      {activeTab === 'all' && (
        <TaskList
          tasks={displayTasks}
          mode="List"
          sortBy={sortBy}
          setSortBy={setSortBy}
          onViewTask={onViewTask}
          today={today}
          tomorrow={tomorrow}
          taskTypes={taskTypes}
          undoComplete={undoComplete}
          onMoveTask={onMoveTask}
          onAddTask={onAddTask}
          currentUser={currentUser}
        />
      )}

      {activeTab === 'calendar' && (
        <CalendarView
          calendarDate={calendarDate}
          setCalendarDate={setCalendarDate}
          setSelectedDate={setSelectedDate}
          setShowCalendarModal={setShowCalendarModal}
          tileContent={tileContent}
          tasks={displayTasks}
        />
      )}
    </div>
  );
}

export default TasksPage;
